<template>
  <div>
    <category-user-add
      :is-sidebar-active.sync="isSidebarActive"
      @refresh-data="() => { refCategoryUserList.refreshData() }"
    />
    <list
      ref="refCategoryUserList"
      sort-by="TicketCategoriaUsuarioId"
      refetch-records-name="usuarios"
      key-field="TicketCategoriaUsuarioId"
      :actions="actions"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :refetch-records="fetchCategoryUsers"
      :filters.sync="filters"
      :delete-method="deleteCategoryUser"
    >
      <template #cell(nombreUsuario)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :text="avatarText(data.item.nombreCompleto)"
              variant="light-danger"
            />
          </template>
          <b-link
            class="font-weight-bold d-block text-nowrap"
          >
            {{ data.item.nombreCompleto }}
          </b-link>
          <small class="text-muted">@{{ data.item.nombreUsuario }}</small>
        </b-media>
      </template>
      <template #cell(puedeLeer)="data">
        <b-form-checkbox
          v-model="data.item.puedeLeer"
          @change="onAccessControlChange(data.item.ticketCategoriaUsuarioId, 'puedeLeer', data.item.puedeLeer)"
          :disabled="data.item.tipoAsignacion !== 'Directa'"
        />
      </template>
      <template #cell(puedeReparar)="data">
        <b-form-checkbox
          v-model="data.item.puedeReparar"
          @change="onAccessControlChange(data.item.ticketCategoriaUsuarioId, 'puedeReparar', data.item.puedeReparar)"
          :disabled="data.item.tipoAsignacion !== 'Directa'"
        />
      </template>
    </list>
  </div>
</template>

<script>
import {
  BMedia,
  BAvatar,
  BLink,
  BFormCheckbox,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'
import helpDeskService from '@/services/helpDesk.service'
import List from '@/components/List.vue'
import router from '@/router'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import CategoryUserAdd from './CategoryUserAdd.vue'

export default {
  components: {
    List,
    CategoryUserAdd,
    BMedia,
    BAvatar,
    BLink,
    BFormCheckbox,
  },
  setup() {
    const refCategoryUserList = ref(null)
    const isSidebarActive = ref(false)
    const {
      fetchCategoryUser,
      deleteCategoryUser,
      pathCategoryUser,
    } = helpDeskService()
    const tableColumns = [
      {
        key: 'tipoAsignacion',
        label: i18n.t('AppHelpDesk.categoryUsersColumns.assignationType'),
        sortable: true,
      },
      {
        key: 'nombreUsuario',
        label: i18n.t('AppHelpDesk.categoryUsersColumns.userName'),
        sortable: false,
      },
      {
        key: 'puedeLeer',
        label: i18n.t('AppHelpDesk.categoryUsersColumns.canRead'),
        sortable: false,
      },
      {
        key: 'puedeReparar',
        label: i18n.t('AppHelpDesk.categoryUsersColumns.canFix'),
        sortable: false,
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
        sortable: false,
      },
    ]
    const filters = ref([
      {
        type: 'select',
        name: 'usuarios',
        label: i18n.t('AppHelpDesk.filters.userName'),
        value: '',
        options: [],
        domainName: 'Empleado',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('AppHelpDesk.addUser'),
        aclAction: 'create',
        aclResource: 'MesaAyuda',
        click: () => { isSidebarActive.value = true },
        icon: 'PlusCircleIcon',
      },
    ])
    const tableActions = ref([
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'MesaAyuda',
        params: ['ticketCategoriaUsuarioId'],
        icon: 'TrashIcon',
        disabledCondition: item => item.tipoAsignacion !== 'Directa',
      },
    ])
    const fetchCategoryUsers = (data, callback) => {
      fetchCategoryUser(router.currentRoute.params.ticketCategoriaId, data, callback)
    }
    const onAccessControlChange = (ticketUsuarioCategoriaId, field, value) => {
      pathCategoryUser(ticketUsuarioCategoriaId, [
        {
          value,
          path: `/${field}`,
          op: 'replace',
        },
      ], () => {})
    }
    return {
      refCategoryUserList,
      fetchCategoryUser,
      deleteCategoryUser,
      tableColumns,
      tableActions,
      filters,
      actions,
      isSidebarActive,
      fetchCategoryUsers,
      avatarText,
      onAccessControlChange,
    }
  },
}
</script>
